export default "__VITE_ASSET__D4Ot3QtH__"